// src/features/links/LinkPlatformCounts.tsx
// IR-1386 r4 (Rotem): "add Links per platform - pie chart or a simple count -
// just checking we should now see Telegram, signal and whatsApp here after our
// fix".
//
// A COUNT, not a second ring, and the live data is why: the prod queue at the
// time of writing is Telegram 8,371 · WhatsApp 250 · Signal 34 — 96.7% / 2.9% /
// 0.4%. Drawn as a donut, Signal is a sub-pixel wedge, so the one platform she
// is actually checking on would be the one the chart cannot show. Three plain
// numbers answer "do we see all three now?" in one glance and stay readable at
// any split. (Same discipline as the r3 ring: measure the split before choosing
// the form.)
//
// Zeros are RENDERED, never dropped. "Signal 0" is a real answer; a missing row
// leaves the reader unable to tell "none collected" from "not tracked here".
import { PlatformIcon } from "./PlatformIcon";
import { PLATFORM_LABELS } from "./labels";
import type { Platform } from "./types";

/** Fixed order — matches the Platform filter's option order. */
const ORDER: Platform[] = ["tg", "wa", "signal"];

interface Props {
  counts: Partial<Record<Platform, number>> | null;
}

export function LinkPlatformCounts({ counts }: Props) {
  if (!counts) return null;

  return (
    <div data-testid="link-platform-counts" className="flex flex-col gap-1.5">
      <span className="text-xs font-medium text-[var(--iris-fg-3)]">By platform</span>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        {ORDER.map((p) => {
          const n = counts[p] ?? 0;
          return (
            <span
              key={p}
              className="inline-flex items-center gap-1.5 text-xs"
              // The glyph alone is not a label for anyone who has not learnt
              // it, and this box has no legend beside it the way the ring does.
              title={`${PLATFORM_LABELS[p]}: ${n.toLocaleString()} link${n === 1 ? "" : "s"} in the current view`}
            >
              <PlatformIcon platform={p} />
              <span
                className={
                  n === 0
                    ? "tabular-nums text-[var(--iris-fg-4)]"
                    : "tabular-nums text-[var(--iris-fg-1)]"
                }
              >
                {n.toLocaleString()}
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
